<template>
  <div style="height: 100%;background-color: #fbfbfb;padding: 20px;box-sizing: border-box">
    <div style="height: 50px">
      <el-button type="primary" plain @click="addDevice()">新增</el-button>
      &nbsp;&nbsp;&nbsp;<span>设备编号：</span>
      <el-input placeholder="输入设备编号" v-model="imei" style="width: 250px"></el-input>
      <el-button type="success" @click="queryDataTable">查询</el-button>
    </div>
    <div style="height: calc(100% - 50px);overflow-y: auto;">
      <el-table height="100%" v-loading="loading" element-loading-text="加载中，请耐心等待。" :data="showTable" border style="width: 100%" highlight-current-row>
        <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
        <el-table-column prop="devicesn" label="设备编号" min-width="130" align="center"></el-table-column>
        <el-table-column prop="name" label="设备名称" min-width="100" align="center"></el-table-column>
        <el-table-column prop="" label="功能角色" min-width="100" align="center">
          <template slot-scope="scope">
            <span>门禁</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="指令" width="150">
          <template slot-scope="scope">
            <el-button type="warning" @click="handleClick(scope.row)" size="mini" plain>发送指令</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <i title="详情" class="el-icon-view" style="cursor: pointer; font-size: 18px;color: #002dc0" @click="openShowDetails(scope.row)"></i>
            <i title="编辑" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editDevice(scope.row)"></i>
            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delDevice(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--新增、编辑-->
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="500px" :show-close="true" :close-on-click-modal="true"  center class="all-open">
      <div class="title-top-alarm">
        <div> <span>{{ addEditTitle }}</span> </div>
        <div class="line-title"></div>
      </div>
      <add-edit-face-device v-model="addEditShow" :faceObj="faceObj" @updateTable="queryDataTable"></add-edit-face-device>
    </el-dialog>
    <!--详情-->
    <el-dialog :visible.sync="detailsShow" v-if="detailsShow" width="600px" :show-close="true" :close-on-click-modal="true"  center class="all-open">
      <div class="title-top-alarm">
        <div> <span>{{ detailsTitle }}</span> </div>
<!--        <div class="line-title"></div>-->
      </div>
      <face-person v-model="detailsShow" :faceObj="faceObj"></face-person>
    </el-dialog>
  </div>
</template>

<script>
import {facedevice, facedevicedelete, facedeviceuserlist} from '../../api/yanglaoyuan'
import facePerson from './components/facePerson.vue'
import changeDevice from '../datamanagement/deviceComponents/changeDevice.vue'
import addEditFaceDevice from './components/addEditFaceDevice.vue'
export default {
  name: 'faceDevice',
  components: {changeDevice, facePerson, addEditFaceDevice},
  data () {
    return {
      imei: '',
      loading: false,
      showTable: [],
      addEditTitle: '',
      addEditShow: false,
      faceObj: {
        row: '',
        isAdd: true
      },
      detailsShow: false,
      detailsTitle: ''
    }
  },
  created () {
  },
  mounted () {
    this.queryDataTable()
  },
  methods: {
    queryDataTable () {
      this.loading = true
      let data = {
        orgid: this.$store.state.user.orgid
      }
      facedevice(data).then(res => {
        this.loading = false
        this.showTable = res.data.devices
      }).catch(() => {
        this.loading = false
      })
    },
    addDevice () {
      this.addEditTitle = '新增门禁'
      this.faceObj.row = ''
      this.faceObj.isAdd = true
      this.addEditShow = true
    },
    editDevice (row) {
      this.addEditTitle = '编辑门禁'
      this.faceObj.row = row
      this.faceObj.isAdd = false
      this.addEditShow = true
    },
    delDevice (row) {
      let name = row.name
      let vm = this
      this.$confirm('此操作将永久删除该门禁【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'error'
      }).then(() => {
        let data = {
          id: row.id,
          orgid: row.orgid
        }
        facedevicedelete(data).then(res => {
          this.$notify({title: '成功', message: '删除门禁成功', type: 'success', duration: 2000})
          vm.queryDataTable()
        })
      }).catch(() => {})
    },
    openShowDetails (row) {
      this.faceObj.row = row
      this.detailsTitle = row.name + ' - 录入人员列表'
      this.detailsShow = true
    },
    handleClick (row) {
      let name = row.name
      let vm = this
      this.$confirm('是否向门禁【' + name + '】发送加载用户列表指令？', '发送指令', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'success'
      }).then(() => {
        let data = {
          devicesn: row.devicesn
        }
        facedeviceuserlist(data).then(res => {
          vm.$message({ message: res.data.reason, type: 'success' })
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/faceDevice.vue